import {TokenRepository} from "domain/ports/TokenRepository";
import {TokenValidationResponse} from "domain/types/tokenTypes";

export class TokenService {
    constructor(private tokenRepository: TokenRepository) {
    }

    async validateToken(token: string): Promise<TokenValidationResponse> {
        return this.tokenRepository.validateToken(token);
    }
}